module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNC4wNCI+PHRpdGxlPmRpc3RhbmNlPC90aXRsZT48cGF0aCBkPSJNMTIsMTJhMywzLDAsMSwxLDMtM0EzLDMsMCwwLDEsMTIsMTJabTAtNWEyLDIsMCwxLDAsMiwyQTIsMiwwLDAsMCwxMiw3WiIvPjxwYXRoIGQ9Ik0xMiwyMmgtLjI0bC0uMTctLjJDMTAuOTIsMjEsNSwxMy40OCw1LDlBNyw3LDAsMCwxLDE5LDljMCw0LjQ2LTUuOTIsMTItNi42LDEyLjc5bC0uMTUuMTlaTTEyLDNBNiw2LDAsMCwwLDYsOWMwLDMuNjQsNC42Miw5LjksNiwxMS42OSwxLjM4LTEuNzksNi04LDYtMTEuNjlBNiw2LDAsMCwwLDEyLDNaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/24px-distance.svg
// module id = 1643
// module chunks = 1